{
  "inlineNotification.commentLabel": "Kommentar",
  "inlineNotification.reasonLabel": "Årsag",
  "toggleAll": "Vælg alle",
  "select": "Vælg",
  "status.pending": "Ikke startet",
  "search": "Søg",
  "filter": "filtrer",
  "noSearchResults": "Ingen søgeresultater",
  "status.new": "Ny!",
  "status.waiting": "Afventer",
  "status.in-progress": "I gang",
  "status.fail": "Afvist",
  "status.success": "Gennemført",
  "nextPage": "Næste side",
  "previousPage": "Forrige side",
  "unread_one": "ulæst",
  "unread_other": "ulæste",
  "close": "Luk",
  "pagination.summary": "{{ current }} ud af {{ length }}",
  "notifications_one": "notifikation",
  "notifications_other": "notifikationer",
  "unreadNotifications_one": "{{ count }} $t(unread_one) $t(notification_one)",
  "unreadNotifications_other": "{{ count }} $t(unread_other) $t(notification_other)",
  "since": "{{ date, timeSince }} siden",
  "docs.saveAs": "Gem som {{ format }}",
  "date": "Dato",
  "save": "Gem",
  "cancel": "Anuller",
  "table.edit": "Indstil tabel",
  "table.hideColumn": "Skjul kolonne",
  "table.fullscreen": "Fuld skærm",
  "table.close": "Luk fuld skærm",
  "table.export": "Eksporter",
  "table.filterLoanType": "Aftaletype",
  "table.filterDate": "Skæringsdato",
  "table.setupDescription": "Du kan ændre rækkefølgen af kolonner ved at trække i felterne nedenunder.",
  "table.addProjectName": "Tilføj a projektnavn",
  "table.editProjectName": "Rediger projektnavn",
  "table.projectNameModalDescription": "Projektnavn vil slå igennem på tværs af din organisation",
  "table.saveSettings": "Gem indstillinger",
  "table.clearFilters": "Ryd filtre",
  "table.sort.asc": "Sorter stigende",
  "table.sort.desc": "Sorter faldende",
  "table.sort.none": "Ryd sortering",
  "table.filter.clear": "Ryd filtre",
  "table.filter.showResults_one": "Vis {{ count }} resultat",
  "table.filter.showResults_other": "Vis {{ count }} resultater",
  "form.input.required": "Feltet er påkrævet",
  "selectMonth": "Vælg måned",
  "selectYear": "Vælg år",
  "datepicker.quickSelect.yearsAfter": "{{ count }} år efter {{ date }}",
  "days_one": "{{ count }} dag",
  "days_other": "{{ count }} dage",
  "pastDeadline": "Overskredet",
  "expiredBy": "Udløbet {{ date }}",
  "calculationComparison.hide": "Skjul beregning",
  "calculationComparison.viewDetails": "Se detaljer",
  "calculation.budgetSecurity.Low": "Lav budgetsikkerhed",
  "calculation.budgetSecurity.Medium": "Mellem budgetsikkerhed",
  "calculation.budgetSecurity.High": "Høj budgetsikkerhed",
  "calculation.budgetSecurity.Undefined": "Budgetsikkerhed ikke tilgængelig",
  "year_one": "år",
  "year_other": "år",
  "notRelevant": "Ikke relevant",
  "unavailable": "Ikke tilgængelig",
  "currency": "Valuta",
  "loanPeriod": "løbetid",
  "fixedInterestPeriod": "Rentebinding",
  "fixedInterestPeriod.cibor": "Rentebinding (KK tillæg)",
  "rateFrequency": "rentefrekvens",
  "amortizationProfile": "afdragsprofil",
  "amortizationProfile.Custom": "Ikke tilgængelig",
  "amortizationProfile.UnDefined": "Ikke tilgængelig",
  "loan.loanProduct": "Produkttype",
  "loan.loanInformation": "Aftaleoplysninger",
  "loan.priceInformation": "Prisoplysninger",
  "loan.amortizationProfile": "afdragsprofil",
  "loan.firstInterestDate": "Første rentebetaling",
  "loan.currency": "Valuta",
  "loan.currentRate": "Aktuel rentesats",
  "loan.currentRate.tooltip": "Inkl. KK tillæg",
  "loan.spread.cibor": "— Heraf KK tillæg",
  "loan.marginRate": "Aktuel bidragssats",
  "loan.initialCosts": "Etableringsomkostninger",
  "loan.firstPayment": "Første ydelse",
  "loan.principalAmount": "Hovedstol",
  "loan.principalAmount.credit": "Kreditmaksimum",
  "loan.interestPaymentFrequency.UnDefined": "Ikke tilgængelig",
  "loan.interestPaymentFrequency.M1": "Månedlig",
  "loan.interestPaymentFrequency.M2": "Ikke tilgængelig",
  "loan.interestPaymentFrequency.M3": "Kvartårlig",
  "loan.interestPaymentFrequency.M4": "Ikke tilgængelig",
  "loan.interestPaymentFrequency.M6": "Halvårlig",
  "loan.interestPaymentFrequency.M12": "Årlig",
  "loanProduct.KKfast": "KKfast",
  "loanProduct.KKfast.description": "Renten er den samme i lånets løbetid, og renteudgiften ligger derfor fast i hele perioden.",
  "loanProduct.KKvar": "KKvar",
  "loanProduct.KKvar.description": "Renten er variabel. KommuneKredit fastsætter løbende renten i forhold til, hvordan renten i markedet udvikler sig.",
  "loanProduct.KKcibor": "KKcibor",
  "loanProduct.KKcibor.description": "Renten er variabel og består af den danske referencerente, CIBOR, samt et fast tillæg eller fradrag.",
  "loanProduct.Byggekredit": "Byggekredit",
  "loanProduct.Byggekredit.description": "Renten er variabel, og I betaler kun rente af det beløb, I har trukket. Byggekreditten kan kun bruges til bygge- eller anlægsprojekter og skal indfries eller omlægges til lån, når byggeriet er færdigt.",
  "amortizationProfile.Bullet": "Stående",
  "amortizationProfile.Annuity": "Annuitetslån",
  "amortizationProfile.Annuity.description": "Ydelsen er den samme hver termin. I starten betaler I mest i rente. Senere falder renterne, og afdraget stiger.",
  "amortizationProfile.Serial": "Serielån",
  "amortizationProfile.Serial.description": "Ydelsen falder i løbet af lånets løbetid. Afdraget er det samme hver termin, mens renteudgiften falder over tid.",
  "fixedInterestPeriod.ToMaturity": "Hele løbetiden",
  "fixedInterestPeriod.Cheapest": "Billigste renteaftale",
  "rateFrequency.M6": "Halvårlig",
  "rateFrequency.M3": "Kvartårlig",
  "calculatorForm.principalAmount.description": "Hvor meget ønsker I at låne?",
  "calculatorForm.loanPeriod.label": "løbetid",
  "calculatorForm.loanPeriod.description": "Hvor mange år ønsker i at låne pengene?",
  "calculatorForm.loanPeriod.placeholder": "Vælg løbetid",
  "calculatorForm.loanProduct.label": "produkttype",
  "calculatorForm.loanProduct.placeholder": "Vælg produkttype",
  "calculatorForm.loanProduct.description": "Hvilket lån passer bedst til jeres behov?",
  "calculatorForm.amortizationProfile.label": "afdragsprofil",
  "calculatorForm.amortizationProfile.placeholder": "Vælg afdragsprofil",
  "calculatorForm.amortizationProfile.description": "Hvordan ønsker i at afdrage på lånet?",
  "calculatorForm.fixedInterestPeriod.label": "Rentebinding",
  "calculatorForm.fixedInterestPeriod.placeholder": "Vælg periode for rentebinding",
  "calculatorForm.fixedInterestPeriod.description": "Hvor mange år skal renten være fast?",
  "calculatorForm.rateFrequency.label": "rentefrekvens",
  "calculatorForm.rateFrequency.placeholder": "Vælg rentefrekvens",
  "calculatorForm.rateFrequency.description": "Hvor ofte vil I betale renter?",
  "calculatorForm.submit": "Beregn",
  "calculator.disclaimer.title": "Forbehold",
  "calculator.disclaimer.description": "Beregningen er vejledende og er ikke et bindende tilbud om lån. Beregningen er baseret på aktuelle markedsvilkår og kan ændre sig fra dag til dag.\n\nØnsker I et lån, er det en god idé at kontakte os så tidligt som muligt i processen – gerne inden I træffer en endelig beslutning om jeres investering. Send jeres ansøgning til <1>{{ email }}</1>",
  "calculator.disclaimer.linkLabel": "Læs om låneprocessen",
  "standalone.newInterestAgreement": "Ny renteaftale",
  "standalone.determineAtTerm": "Fastsættes ved termin",
  "data.valueDate": "Valørdato",
  "data.repayment": "Afdrag",
  "data.interest": "Rente",
  "data.margin": "Bidrag",
  "data.payment": "Ydelse",
  "data.notionalAmount": "Restgæld"
}
